export class DrugInteractions {
    drugOne = null;
    drugTwo = null;
    description = null;
}